var css = {"page":"Paginator-module_page__DsfdI","break":"Paginator-module_break__WAqZ4"};

export { css as default };
